export const errorPages = {
    'error.page.404.title': 'Ошибка 404',
    'error.page.404.text': 'Вы что-то искали здесь? Похоже, здесь больше ничего нет',
    'error.page.500.title': 'Ошибка 500',
    'error.page.500.text': 'Кажется, что-то пошло не так. Мы уже работаем над устранением проблемы, попробуйте зайти на платформу позже',
    'error.page.503.title': 'Ошибка 503',
    'error.page.503.text': 'В данный момент сервер временно недоступен, но мы уже решаем проблему. Пожалуйста, подождите немного и попробуйте снова войти',
    'error.page.support.button': 'Есть вопрос? Напишите в нашу службу поддержки',
}
